import * as React from 'react';

import { Flex, Input, Typography } from 'antd';

import { AntdDateRangePicker } from 'components';

type PurchasesHeaderProps = {
  searchKey: string;
  handleSearchKey: (searchKey: string) => void;
  handleLowerBoundCreateDate: (lowerBoundCreateDate?: string) => void;
  handleUpperBoundCreateDate: (upperBoundCreateDate?: string) => void;
};

const PurchasesHeader = ({
  searchKey,
  handleSearchKey,
  handleLowerBoundCreateDate,
  handleUpperBoundCreateDate,
}: PurchasesHeaderProps) => (
  <Flex
    gap='middle'
    className='mb-5 max-lg:flex-col lg:items-center lg:justify-between'
  >
    <Typography.Title level={1} className='mb-0 text-nowrap text-lg'>
      سفارش‌ها
    </Typography.Title>
    <Flex gap='small' className='max-lg:flex-wrap'>
      <Input.Search
        allowClear
        className='max-lg:basis-full'
        styles={{
          affixWrapper: {
            height: '2.5rem',
          },
        }}
        placeholder='جستجوی سفارش‌ها'
        defaultValue={searchKey}
        onSearch={value => handleSearchKey(value)}
      />
      <AntdDateRangePicker
        allowEmpty
        className='max-lg:basis-full'
        onDateChange={([lowerBoundCreateDate, upperBoundCreateDate]) => {
          handleLowerBoundCreateDate(lowerBoundCreateDate);
          handleUpperBoundCreateDate(upperBoundCreateDate);
        }}
      />
    </Flex>
  </Flex>
);

export { PurchasesHeader };
